import * as React from 'react';
import Affix from '@telia-front/affix';
import Container from '@telia-front/container';
import ContentTable from './content-table';
import HeaderTable from './header-table';
const DesktopComparison = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Affix, { className: "product-comparison__affix" },
            React.createElement("div", { className: "product-comparison__wrapper" },
                React.createElement(Container, { className: "product-comparison__container" },
                    React.createElement(HeaderTable, { deviceLabel: props.deviceLabel, placeholder: props.placeholder, items: props.items, title: props.title, compareCheckLabel: props.compareCheckLabel, isCompareChecked: props.isCompareChecked, onCompareCheckChange: props.onCompareCheckChange })))),
        React.createElement(Container, { className: "product-comparison__content-wrapper" }, props.categories.map((category) => {
            return React.createElement(ContentTable, { key: category.id, category: category, label: category.label, items: props.items, deviceLabel: props.deviceLabel });
        }))));
};
export default DesktopComparison;
